import React from 'react'
import { useIntl } from 'react-intl'

import { faSignOutAlt } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from 'antd'
import PropTypes from 'prop-types'

function DesktopView({ handleSignOut }) {
  const intl = useIntl()

  return (
    <Button
      block
      type="text"
      onClick={handleSignOut}
      style={{
        fontSize: 14,
        alignSelf: 'center',
        cursor: 'pointer',
        textAlign: 'left',
        padding: 2,
      }}
      icon={
        <FontAwesomeIcon
          icon={faSignOutAlt}
          style={{ fontSize: 16, marginRight: '6px' }}
        />
      }
      data-testid="signoutid"
    >
      {intl.formatMessage({
        id: 'global.labels.exit',
      })}
    </Button>
  )
}

DesktopView.propTypes = {
  handleSignOut: PropTypes.func.isRequired,
}

export default DesktopView
